/* eslint-disable internal-rules/no-unused-properties */
export const PermissionsPlugin = {
    install (Vue, opts) {
        Vue.mixin({
            methods: {
                $can (...args) {
                    return opts.store.getters['auth/can'](...args);
                },
                $canAll (...args) {
                    return opts.store.getters['auth/canAll'](...args);
                },
                $canAny (...args) {
                    return opts.store.getters['auth/canAny'](...args);
                },
            },
        });
    },
};
